"use client";
import Link from "next/link";
import { Stack, Text, Heading, Button } from "@chakra-ui/react";
import { ListWithLabel, ListWithLabelProps } from "../list";
import {
  useSectionHeadingVariant,
  useTextVariants,
} from "@/theme/components/useSectionHeading";
import { BUTTON_VARIANTS } from "@/theme/components/button";

type CardProps = {
  button?: { label: string; link: string };
  description?: string[];
  extraContent?: string;
  features?: ListWithLabelProps["points"];
  title?: string;
};

const CtaCard = (props: CardProps) => {
  const { button, description, extraContent, features, title } = props;
  const HeadingVariant = useSectionHeadingVariant();
  const textVariant = useTextVariants();
  return (
    <Stack
      backgroundColor="primary.200"
      color="white"
      spacing={8}
      p={{ base: 6, md: 12 }}
      borderRadius={"8px"}
    >
      <Stack spacing={4}>
        <Heading as="h2" variant={HeadingVariant}>
          {title}
        </Heading>
        {description && (
          <Stack spacing={1}>
            {description.map((desc, index) => (
              <Text key={index} variant={textVariant}>
                {desc}
              </Text>
            ))}
          </Stack>
        )}
        {features && <ListWithLabel points={features} separator="–" textColor="white" />}
      </Stack>
      {extraContent && (
        <Text variant={textVariant} color="white">
          {extraContent}
        </Text>
      )}
      {button && (
        <Button
          as={Link}
          variant={BUTTON_VARIANTS.SECONDARY}
          href={button.link}
          width={"fit-content"}
          whiteSpace="normal"
        >
          {button.label}
        </Button>
      )}
    </Stack>
  );
};

export default CtaCard;
